
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { ImageUploadField } from "./ImageUploadField";

interface BasicOptionFieldsProps {
  form: UseFormReturn<any>;
}

export function BasicOptionFields({ form }: BasicOptionFieldsProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="option_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Option Name</FormLabel>
              <FormControl>
                <Input placeholder="e.g., Size, Color, Material" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="option_value"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Option Value</FormLabel>
              <FormControl>
                <Input placeholder="e.g., Large, Red, Cotton" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <ImageUploadField form={form} />
    </div>
  );
}
